import BaseAttachableListManager from './BaseAttachableListManager';

export default class LabelArtistManager extends BaseAttachableListManager {
    constructor(options = {}) {
        super({
            containerSelector: '.label-artist-manager-container',
            detachItemSelector: '.detach-artist',
            detachDataKey: 'artist-id',
            notificationContainerId: 'label-artist-manager-notifications',
            ...options,
        });

        this.availableArtists = options.availableArtists || {};
    }

    bindBaseEvents() {
        $(document).off('.labelArtistManager');

        $(document).on('click.labelArtistManager', '.attach-label-artist', () => {
            $('#artistSelect').val('');
            $('#attachArtistModal').modal('show');
        });

        $(document).on('click.labelArtistManager', '#attach-artist-button', () => {
            this.handleAttachSubmit();
        });

        $(document).on('click.labelArtistManager', '.detach-artist', (e) => {
            const artistId = $(e.target).closest('.detach-artist').data('artist-id');
            const artistName = $(e.target).closest('tr').find('td[field-key="name"]').text().trim();

            this.confirmAction(`Rimuovere "${artistName}" dalla label?`, 'Sì, rimuovi').then((confirmed) => {
                if (confirmed) {
                    this.detachArtist(artistId);
                }
            });
        });

        $(document).on('hidden.bs.modal.labelArtistManager', '#attachArtistModal', () => {
            $('#artistSelect').val('');
        });
    }

    handleAttachSubmit() {
        const artistId = $('#artistSelect').val();

        if (!artistId) {
            this.showNotification('Seleziona un artista', 'error');
            return;
        }

        const attachButton = $('#attach-artist-button');
        this.showLoading(attachButton, true);

        this.makeRequest(
            this.attachRoute,
            'PATCH',
            { artist_id: artistId },
            () => {
                this.showLoading(attachButton, false);
                this.showNotification('Artista aggiunto con successo!', 'success');
                $('#attachArtistModal').modal('hide');
                setTimeout(() => location.reload(), 800);
            },
            (xhr) => {
                this.showLoading(attachButton, false);
                this.showNotification(`Errore: ${this.extractErrorMessage(xhr)}`, 'error');
            }
        );
    }

    detachArtist(artistId) {
        if (!artistId) {
            this.showNotification('ID artista non valido', 'error');
            return;
        }

        const detachButton = $(`.detach-artist[data-artist-id="${artistId}"]`);
        this.showLoading(detachButton, true);

        this.makeRequest(
            this.detachRoute,
            'DELETE',
            { artist_id: artistId },
            () => {
                this.showLoading(detachButton, false);
                this.showNotification('Artista rimosso dalla label', 'success');
                location.reload();
            },
            (xhr) => {
                this.showLoading(detachButton, false);
                this.showNotification(`Errore: ${this.extractErrorMessage(xhr)}`, 'error');
            }
        );
    }
}

window.initLabelArtistManager = function () {
    const $container = $('.label-artist-manager-container');
    if ($container.length === 0) {
        return;
    }

    if (window.labelArtistManager?.sortableInstance) {
        window.labelArtistManager.sortableInstance.destroy();
    }

    const options = BaseAttachableListManager.optionsFromContainer($container, {
        containerSelector: '.label-artist-manager-container',
        detachItemSelector: '.detach-artist',
        detachDataKey: 'artist-id',
        notificationContainerId: 'label-artist-manager-notifications',
        extraOptions: {
            availableArtists: $container.data('available-artists') || {},
        },
    });

    window.labelArtistManager = new LabelArtistManager(options);
};

$(document).ready(function () {
    window.initLabelArtistManager();
});
